import { IconReceipt2 } from '@tabler/icons';
import {
  Button,
  Modal,
  ModalBody,
  ModalDescription,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  Usd,
} from '#root/components/ui';
import type { MatchOrderDTO } from '#root/models/PrepaidMatchDTO';
import { taxPhrase } from './matchFormat';
import styles from './match.module.scss';

interface MatchPriceDialogProps {
  open: boolean;
  onClose: () => void;
  /** Se conserva al cerrar para que la animación de salida no pierda el contenido */
  order: MatchOrderDTO;
}

/** Qué es el precio real y la comisión neta de un pedido Match, con su total */
const MatchPriceDialog = ({ open, onClose, order }: MatchPriceDialogProps) => {
  // Sin tax (`tax_percent: 0`) no se menciona tax ni la diferencia contra el de su ciudad
  const tax = taxPhrase(order.tax_percent);
  // Redondeado a centavos: sumar decimales en coma flotante deja restos
  const total = Math.round((order.price + order.earning) * 100) / 100;

  return (
    <Modal open={open} onClose={onClose} size="sm">
      <ModalHeader icon={<IconReceipt2 />} tone="info">
        <ModalTitle>Precio real y comisión neta</ModalTitle>
        <ModalDescription>{order.name}</ModalDescription>
      </ModalHeader>
      <ModalBody>
        <dl className={styles.terms}>
          <div className={styles.term}>
            <dt>
              <span>Precio real</span>
              <strong>
                <Usd value={order.price} />
              </strong>
            </dt>
            <dd>
              Lo que cuesta en la tienda{tax && `, ${tax}`}.
              {tax &&
                ' Si el tax de tu ciudad es mayor, la diferencia sale de tu comisión; si es menor, la ganas.'}
            </dd>
          </div>
          <div className={`${styles.term} ${order.boost > 0 ? styles.boosted : ''}`}>
            <dt>
              <span>Comisión neta</span>
              <strong>
                <Usd value={order.earning} />
              </strong>
            </dt>
            <dd>Lo que ganas por traerlo, con el fee de Guvery ya descontado.</dd>
            {/* Un BE sin booster no manda `boost`: `undefined > 0` es false */}
            {order.boost > 0 && (
              <dd>
                Incluye <Usd value={order.boost} /> de comisión mejorada
              </dd>
            )}
          </div>
        </dl>
        <p className={styles.priceTotal}>
          En total recibes{' '}
          <strong>
            <Usd value={total} />
          </strong>
          : el precio real más tu comisión neta.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose}>Entendido</Button>
      </ModalFooter>
    </Modal>
  );
};

export default MatchPriceDialog;
